const subjects = [
  {
    heading: 'I am an Employee',
    subtitle:
      'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
    listItems: [
      { info: 'Residency', status: true },
      { info: 'Submit Documents', status: false },
      { info: 'Submit Receipt', status: false },
    ],
  },
  {
    heading: 'I am a Company',
    subtitle:
      'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
    listItems: [
      { info: 'Residency', status: true },
      { info: 'Submit Documents', status: false },
      { info: 'Submit Receipt', status: false },
    ],
  },
  {
    heading: 'I am an Entrepeneur',
    subtitle:
      'Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum',
    listItems: [
      { info: 'Residency', status: true },
      { info: 'Submit Documents', status: false },
      { info: 'Submit Receipt', status: false },
    ],
  },
];

export default subjects;
